module.exports = __webpack_public_path__ + "static/img/runway.7cd26dcb.png";